// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_1P9nv){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_2yhw2 .dualColumn_1V5u9{display:flex;align-content:space-between}.nsAddressForm_2yhw2 .dualColumn_1V5u9 .firstCol_3haEw{margin-right:20px}.optional_3bnG5{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_1P9nv",
	"nsAddressForm": "nsAddressForm_2yhw2",
	"dualColumn": "dualColumn_1V5u9",
	"firstCol": "firstCol_3haEw",
	"optional": "optional_3bnG5"
};
module.exports = exports;
